<script setup>
import { computed, ref } from 'vue';
import { Icon, Dropdown, Button, DropdownList } from "@components";

import { useRoute, useRouter } from 'vue-router';
const route = useRoute();
const router = useRouter();

import { useGeneral } from '@store/general';
const { topbarDropdownMenus, sidebarOptions, collapseSideMenu } = useGeneral();

import { isLg, isXl, isSm } from '@utils/mediaQuery';

/**
 * Returns the title of the current route from the router's metadata.
 * 
 * @returns {string} The title of the current route.
 */
const pageTitle = () => {
    return route.meta.title || '';
};

const dropdownList = computed(() => {
    return topbarDropdownMenus.filter(menu => access(menu.link.name) == true && (menu.visibility == undefined || menu.visibility)) || [];
});

import { useSettings } from '@store/settings';
const $settings = useSettings();
</script>

<template>
<div class="md:h-[88px] border-b border-[#EAECF0] !py-3 md:py-6 flex items-center justify-between"
    :style="[(isLg || isXl) && !$settings.isRTL ? `padding-left:${isSm ? '12px' : sidebarOptions.sidebarWidth};padding-right:32px;` : `padding-left:${isSm ? '12px' : '32px'};padding-right:${isSm ? '12px' : isLg ? sidebarOptions.sidebarWidth : '12px'}`]">
    <!-- sidebar collapse/expand icon -->
    <div class="flex items-center gap-5 text-[#101828] text-lg font-semibold"
        :class="$settings.isRTL ? 'pr-5' : 'md:pl-5'">
        <Icon @click="collapseSideMenu()" name="chevronLeftDouble" size="20px"
            :class="`${sidebarOptions.sidebarCollapse == true ? 'rotate-180' : ''} capitalize transition-all duration-500 text-[#667085] cursor-pointer`" />
        {{ pageTitle() }}
    </div>

    <!-- topbar right side dropdown -->
    <Dropdown :contentClass="`w-56 top-[72px] ${$settings.isRTL ? 'left-0' : 'right-0'}`"
        v-show="route.meta.topBarActions">
        <Button size="md" type="primary" radius="square">
            Add New
            <template #after>
                <Icon name="chevronDown" size="20px" />
            </template>
        </Button>

        <template #content>
            <DropdownList :menus="dropdownList" />
        </template>
    </Dropdown>
</div>
</template>